import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Grid, Menu, Segment } from 'semantic-ui-react';
import { USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';
import './index.scss'

const ROUTES = {
    users: 'users', 
    company: 'company'
}

const Extensions = () => {
    return <Grid className='Extensions_Container'>
        <Grid.Row style={{ paddingTop: 0, paddingBottom: 0 }}>
            <Grid.Column style={{ paddingTop: '1em', paddingRight: 0, paddingLeft: '0.5em' }}>
                <Menu secondary className='PhoneManagement_generalTabs'>
                    <RestrictedView type="disabled" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}extensions/${ROUTES.users}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                        <Menu.Item name='Users' as={NavLink} to={ROUTES.users} />
                    </RestrictedView>
                    <RestrictedView type="disabled" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}extensions/${ROUTES.company}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                        <Menu.Item name='Company' as={NavLink} to={ROUTES.company} />
                    </RestrictedView>
                </Menu>
                <Segment basic>
                    <Outlet />
                </Segment>
            </Grid.Column>
        </Grid.Row>
    </Grid>;
}

export default Extensions;